<template>
  <div style="display: none;" />
</template>

<script>
export default {
  props: {
    leaderboard: {
      type: Object,
      required: true,
    },
  },

  mounted() {
    const { googletag } = window;
    if (!googletag) return;
    googletag.cmd.push(() => {
      googletag.pubads().addEventListener('slotRenderEnded', ({ slot, isEmpty }) => {
        const slotElementId = slot.getSlotElementId();
        const adUnitPath = slot.getAdUnitPath();
        const outOfPage = slot.getOutOfPage();
        // do not run if the ad is in-page or lacks an element ID
        if (!outOfPage || !slotElementId) return;

        if (isEmpty) {
          if (adUnitPath.includes('top-leaderboard')) {
            // the top leaderboard ad did not return an OOP creative.
            // re-request as a non-oop ad unit.
            this.handleTopLeaderboard({ slot });
          }
          return; // always bails empty ad units, otherwise iframe interaction will throw error.
        }

        /** @type {HTMLIFrameElement} */
        const iframe = document.querySelector(`#${slotElementId} iframe`);
        if (!iframe) return;

        // hide the iframe so it doesn't render an empty height. prevents CLS.
        iframe.style.display = 'none';
        const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
        if (iframeDocument.readyState === 'complete') {
          this.handleFrameContent({ slotElementId, iframeDocument });
        } else {
          iframe.onload = () => this.handleFrameContent({ slotElementId, iframeDocument });
        }
      });
    });
  },

  methods: {
    handleTopLeaderboard({ slot }) {
      const adUnitPath = slot.getAdUnitPath();

      // get the current ad wrapper
      const slotElementId = slot.getSlotElementId();
      const current = document.querySelector(`#${slotElementId}`);
      const { googletag } = window;
      const { leaderboard } = this;

      // create a fresh ad wrapper
      const div = document.createElement('div');
      div.id = this.elementId();
      // apply the current ad wrapper's classes
      current.classList.forEach((name) => div.classList.add(name));
      // define the new slot as non-oop using the current slot's path.
      const newSlot = googletag
        .defineSlot(adUnitPath, leaderboard.size, div.id)
        .addService(googletag.pubads());
      // set the targeting keys to the new slot
      slot.getTargetingKeys().forEach((key) => {
        newSlot.setTargeting(key, slot.getTargeting(key));
      });

      const { sizeMapping } = leaderboard;
      let mapping;
      if (Array.isArray(sizeMapping)) {
        mapping = googletag.sizeMapping();
        sizeMapping.forEach(({ viewport, size }) => {
          mapping.addSize(viewport, size);
        });
      }
      if (mapping) newSlot.defineSizeMapping(mapping.build());

      // insert the new wrapper.
      current.parentElement.prepend(div);

      // and request it!
      googletag.display(div.id);
    },

    /**
     *
     * @param {object} params
     * @param {string} params.slotElementId
     * @param {Document} params.iframeDocument
     */
    handleFrameContent({ slotElementId, iframeDocument }) {
      const container = iframeDocument.querySelector('#oop-ad-creative-container');
      // use the contents from the creative container or the entire iframe body if not present.
      const body = (container || iframeDocument.body);
      const contents = this.mutateContents(body.innerHTML);

      const target = document.querySelector(`#${slotElementId}`);
      target.innerHTML = '';

      window.postscribe(target, contents);
    },

    /**
     *
     * @param {string} contents
     * @returns {string}
     */
    mutateContents(contents) {
      if (!/BBMToaster\.init/.test(contents)) return contents;
      // the BBM toaster in slideout ads expected the code to run before the window was loaded
      // and did _not_ check the actual document state. as such, the toaster will not init anymore
      // in this fashion, so we must add it.
      return contents.replace(`
            window.addEventListener('load', (event) => {
                 BBMToaster.init({ percentage: 20, slideOutPosition: 'left' });
            });
        `, "BBMToaster.init({ percentage: 20, slideOutPosition: 'left' });");
    },

    elementId() {
      return `div-gpt-ad-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
    },
  },
};
</script>
